import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import VisionandMissionQueryEn from '../QueriesEn/VisionandMissionQueryEn';
import VisionandMissionQueryHi from '../QueriesHi/VisionandMissionQueryHi';

const VisionandMissionDataFetcher = ({ setVisionandMissionData, currentLanguage }) => {
  const visionandMissionQuery = currentLanguage === 'en' ? VisionandMissionQueryEn : VisionandMissionQueryHi;

  const { data } = useQuery(visionandMissionQuery, {
    fetchPolicy: 'network-only',
    variables: { language: currentLanguage },
  });

  useEffect(() => {
   
    if (data) {
      const nodes = data.nodeVissionAndMissions.nodes;
      setVisionandMissionData(nodes); // Ensure setVisionandMissionData is correctly passed and a function
      // console.log('Fetched Vision and Mission data:', nodes);
    }
  }, [data, setVisionandMissionData]);

  return null;
};

export default VisionandMissionDataFetcher;
